module.exports = __webpack_public_path__ + "static/media/1014001BE.311ff2a0.jpg";